import * as React from 'react';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { FEATURE_TAGS } from '../utils/FeatureTags';
import { FormText, parseText } from '../utils/utils';

import '../../styles/Question.scss';

const RadioLabel = ({ item, input, handleInput, required }) => {
  const { id, title, body } = item;
  const text = parseText(body || title);
  const textArray =  (text).split(FEATURE_TAGS.answers.others);
  const inputs = Array.from((text).matchAll(new RegExp(FEATURE_TAGS.answers.others, 'g')));
  const elems = [];
  let key = 0;
  for (let i = 0; i < textArray.length; i++) {
    elems.push(<FormText key={`${id}-${key++}`} className='part' data={textArray[i]} />);
    if (i < textArray.length - 1) {
      const width = inputs[i][0].match(/\d+[a-z%]*/);
      elems.push(<TextField
        key={`${id}-${key++}`}
        variant='standard'
        size='small'
        inputProps={{ style: { paddingBottom: 0 } }}
        value={input[`${id}-${i}`] || ''}
        onChange={(e) => handleInput(id, i, e)}
        sx={width ? { width: width[0] } : null}
        required={required}
      />);
    }
  }
  return <div className='answer-label'>
    {elems}
  </div>;
}

export default function Question({
  className,
  name,
  items,
  value,
  onChange,
  focused = false,
  innerRef,
  ...props
}) {
  const handleInput = (id, index, event) => {
    const input = {
      ...value?.input,
      [`${id}-${index}`]: event.target.value,
    }
    handleChange(id, input);
  }

  const onRadioChange = (event) => {
    const itemId = parseInt(event.target.value);
    handleChange(itemId, value?.input || {});
  };

  const handleChange = (itemId, input) => {
    const item = items.find(({ id })=> id === itemId);
    const { title } = item;
    const textArray =  parseText(title).split(FEATURE_TAGS.answers.others);
    let text = '';
    for (let i = 0; i < textArray.length; i++) {
      const inputText = input[`${itemId}-${i}`] || '';
      text += (textArray[i] + inputText);
    }
    onChange({
      value: itemId,
      text,
      input
    }, item);
  };

  return (
    <Box className='question' {...props} ref={innerRef}>
      <FormControl component='fieldset'>
        <FormLabel component='legend' focused={focused} className='question-title'>{name}</FormLabel>
        <RadioGroup
          aria-label={name}
          name={`${name}-radio-buttons-group`}
          value={value?.value || ''}
          onChange={onRadioChange}
        >
          {items.map(item => <FormControlLabel key={item.id} value={item.id} control={<Radio sx={{ marginTop: '-9px' }} required />} label={<RadioLabel item={item} input={value?.input || {}} handleInput={handleInput} required={item.id === value?.value} />} sx={{ alignItems: 'flex-start' , paddingTop: '9px' }} />)}
        </RadioGroup>
      </FormControl>
    </Box>
  );
}